module.exports = __webpack_public_path__ + "img/bespoke70_26.ffbea161.jpg";